import { convertCurrency } from "../components/Common/CommonLogic";

export const quotationLog = (printLog, message) => {
    console.log(printLog, message, "quotationLog")
}
export const findCharge = (breakDown, allFclTariffBreakDowns) => {
    return allFclTariffBreakDowns?.find(data => data?.id === breakDown.chargeId) || {};
};

export const findCurrency = (breakDown, currency_data) => {
    return currency_data?.find(currency => String(currency.currencyCode) === String(breakDown?.currencyCode)) || null;
};

export const findContainer = (breakDown, container_data) => {
    return container_data?.find(container => String(container?.value) === String(breakDown?.containerDetail)) || null;
};

export const findUnitOfMeasurement = (breakDown, UOM_data) => {
    return UOM_data?.find(uom => String(uom?.value) === String(breakDown?.uomCode?.value)) || null;
};

export const mapBreakDown = (breakDown, allFclTariffBreakDowns, currency_data, container_data, UOM_data, tariff) => {
    const charge = findCharge(breakDown, allFclTariffBreakDowns);
    quotationLog(breakDown, "breakDown")
    const result = {
        //id: charge?.id || null,
        //version: charge?.version || 0,
        currency: findCurrency(breakDown, currency_data),
        chargeHeader: tariff?.header,
        //tenantOceanFCLFreightRPId: charge?.tenantOceanFCLFreightRPId || null,
        oceanContainer: findContainer(breakDown, container_data),
        unitOfMeasurement: findUnitOfMeasurement(breakDown, UOM_data),
        unitCost: breakDown?.unit || 0,
        totalBuyCost: breakDown?.unitPerPrice || 0,
        chargeName: typeof breakDown?.component === 'object' && breakDown?.component !== null
            ? breakDown?.component?.label : breakDown?.component || null,
        markupType: breakDown?.markup_type || "PERCENTAGE",
        markupValue: breakDown?.markup_val || 0,
        chargeMarginAmount: breakDown?.margin_value || 0,
        totalSaleCost: breakDown?.total_sale_cost || breakDown?.amount || 0
    };
    quotationLog(result, "result");
    return result;
};


export const processOthersCharge = (mainChargeObj, quoteData, currency_data, container_data, UOM_data) => {
    return mainChargeObj.flatMap((data) =>
        data.tariffDetails.flatMap((tariff) =>
            tariff?.fclTariffBreakDowns.map(breakDown =>
                mapBreakDown(breakDown, getAllFclTariffBreakDowns(quoteData), currency_data, container_data, UOM_data, tariff)
            )
        )
    );
};

export const overAllMarginHandler = (mainChargeObj, quoteObject, currency_ExchangeRate, quotationsValues, subtotalvalue) => {
    let mainChargeCurr = mainChargeObj?.find(obj => obj.id === quoteObject.quote_id) || [];

    const totalMarginSum = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
        let innerSum = 0;
        if (currentOuter?.selected) {
            innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, quotationsValues);
            }, 0);
        }
        return accOuter + innerSum;
    }, 0);

    const totalNewMarginSum = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
        let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
            return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, quotationsValues);
        }, 0);
        return accOuter + innerSum;
    }, 0) : 0;


    let totalMargin = totalMarginSum + totalNewMarginSum;
    let buyvalue = subtotalvalue - totalMargin

    return (totalMargin * 100 / buyvalue).toFixed(2)
}

export const getAllFclTariffBreakDowns = (quoteData) => {
    return quoteData?.flatMap(item =>
        item.tariffDetails?.flatMap(tariff => tariff.fclTariffBreakDowns || [])
    ) || [];
}

export const getOriginalQuoteData = (dataObj, quoteData, container_data, UOM_data, currency_data) => {
    return dataObj.tariffDetails.flatMap(tariffItem => {
        if (!tariffItem.selected) return []; // Skip if not selected
        return tariffItem.fclTariffBreakDowns.map(breakDown => {
            const charge = getAllFclTariffBreakDowns(quoteData)?.find(data => data?.chargeId === breakDown.chargeId);
            return {
                //id: charge?.chargeId || 0,
                //version: charge?.version || 0,
                currency: currency_data?.find(currency => String(currency.currencyCode) === String(breakDown?.currencyCode)) || null,
                chargeHeader: tariffItem?.header,
                //tenantOceanFCLFreightRPId: charge?.tenantOceanFCLFreightRPId || 0,
                oceanContainer: container_data?.find(container => String(container?.value) === String(breakDown?.containerDetail)) || charge?.oceanContainer,
                unitOfMeasurement: UOM_data?.find(uom => String(uom?.value) === String(breakDown?.uomCode)) || null,
                unitCost: breakDown?.unit || 0,
                totalBuyCost: breakDown?.unitPerPrice || 0,
                chargeName: breakDown?.component || null,
                markupType: breakDown?.markup_type || "PERCENTAGE",
                markupValue: breakDown?.markup_val ?? 0,
                chargeMarginAmount: breakDown?.margin_value || 0,
                totalSaleCost: breakDown?.total_sale_cost || breakDown?.amount || 0
            };
        });
    });
}

export const getAirOriginalQuoteData = (dataObj, quoteData, container_data, UOM_data, currency_data) => {
    //console.log("getAirOriginalQuoteData", dataObj, quoteData, container_data, UOM_data, currency_data);
    return dataObj.tariffDetails.flatMap(tariffItem => {
        return tariffItem.fclTariffBreakDowns.map(breakDown => {
            const charge = getAllFclTariffBreakDowns(quoteData)?.find(data => data?.chargeId === breakDown.chargeId);
            return {
                //id: charge?.chargeId || 0,
                //version: charge?.version || 0,
                currency: currency_data?.find(currency => String(currency.currencyCode) === String(breakDown?.currencyCode)) || null,
                chargeHeader: tariffItem?.header,
                //tenantOceanFCLFreightRPId: charge?.tenantOceanFCLFreightRPId || 0,
                unitOfMeasurement: UOM_data?.find(uom => String(uom?.value) === String(breakDown?.chargeBasis)) || null,
                unitCost: breakDown?.unitPrice || 0,
                totalBuyCost: breakDown?.unitPerPrice || 0,
                chargeName: breakDown?.chargeName || null,
                totalSaleCost: breakDown?.totalSaleCost || breakDown?.amount || 0
            };
        });
    });
}

export const subTotalHandler = (mainChargeObj, quoteObject, currency_ExchangeRate, quotationsValues) => {
    console.log("subTotalHandler", mainChargeObj, quoteObject, currency_ExchangeRate, quotationsValues);
    let mainChargeCurr = mainChargeObj?.find(obj => obj.id === quoteObject.quote_id) || [];

    const totalSum = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
        let innerSum = 0;
        if (currentOuter?.selected) {
            innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                return accInner + convertCurrency(currentInner, Number(currentInner.amount), currency_ExchangeRate, quotationsValues);
            }, 0);
        }
        return accOuter + innerSum;
    }, 0);
    const totalMarginSum = quoteObject?.tariffDetails?.reduce((accOuter, currentOuter) => {
        let innerSum = 0;
        if (currentOuter?.selected) {
            innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
                return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, quotationsValues);
            }, 0);
        }
        return accOuter + innerSum;
    }, 0);

    const newSubTotal = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
        let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
            let totalAmt = Number(currentInner.unitPerPrice || 0) * Number(currentInner.unit || 1);
            return accInner + convertCurrency(currentInner, Number(totalAmt), currency_ExchangeRate, quotationsValues);;
        }, 0);
        return accOuter + innerSum;
    }, 0) : 0;

    const totalNewMarginSum = mainChargeCurr?.tariffDetails !== undefined ? mainChargeCurr?.tariffDetails?.reduce((accOuter, currentOuter) => {
        let innerSum = currentOuter?.fclTariffBreakDowns?.reduce((accInner, currentInner) => {
            return accInner + convertCurrency(currentInner, currentInner?.margin_value, currency_ExchangeRate, quotationsValues);
        }, 0);
        return accOuter + innerSum;
    }, 0) : 0;
    let mainTotal = totalSum + newSubTotal + totalMarginSum + totalNewMarginSum;
    return Math.ceil(mainTotal);
}

export function getMainChargeObjRemoveEmpty(mainChargeObj) {
    if (!mainChargeObj || !mainChargeObj[0] || !Array.isArray(mainChargeObj[0].tariffDetails)) return [];
    return mainChargeObj[0].tariffDetails.filter(tariff =>
        Array.isArray(tariff.fclTariffBreakDowns) && tariff.fclTariffBreakDowns.length > 0
    );
}